{
  "field": {
    "lengthYards": 120,
    "widthYards": 53.333,
    "endZoneYards": 10,
    "hashFromCenterYards": 3.083,
    "hashLengthYards": 0.667,
    "lineWidthYards": 0.13,
    "yardLineEveryYards": 5,
    "numberEveryYards": 10,
    "numberHeightYards": 2,
    "numberFromSidelineYards": 10,
    "stripeEveryYards": 5,
    "texturePxPerYard": 24,
    "endZoneLogoHeightFraction": 0.75,
    "endZoneLogoMaxWidthFraction": 0.8,
    "surroundYards": 30,
    "wallOffsetYards": 8,
    "wallHeightYards": 1.5,
    "markerLineWidthYards": 0.25,
    "markerLineLiftYards": 0.01,
    "grassNoise": 0.07,
    "wearPatches": 70,
    "wearMaxAlpha": 0.22,
    "detailRepeatYards": 1.6,
    "detailStrength": 0.35,
    "numberArrowYards": 0.6,
    "routeBackLineMarginYards": 2,
    "routeSidelineMarginYards": 1.5,
    "routeBackLineRunYards": 4,
    "routeLaneMinYards": 1.5,
    "wearSpreadYards": 9
  },
  "goalpost": {
    "baseHeightYards": 3.333,
    "uprightGapYards": 6.167,
    "uprightHeightYards": 10,
    "radiusYards": 0.1,
    "radialSegments": 8
  },
  "camera": {
    "backYards": 13,
    "upYards": 13,
    "pitchDeg": 10,
    "fovDeg": 62,
    "near": 0.5,
    "far": 400,
    "lookAheadYards": 11,
    "lookHeightYards": 0,
    "shift": -0.1,
    "insideFieldYards": 4
  },
  "render": {
    "maxPixelRatio": 2,
    "minPixelRatio": 1,
    "pixelRatioStep": 0.25,
    "targetFps": 55,
    "stepUpFps": 58,
    "sampleSeconds": 2,
    "warmupSeconds": 4,
    "retrySeconds": 20,
    "retryBackoff": 2,
    "anisotropy": 8,
    "maxFrameSeconds": 0.25
  },
  "players": {
    "bodyRadiusYards": 0.38,
    "bodyLengthYards": 0.8,
    "helmetRadiusYards": 0.34,
    "numberSizeYards": 0.75,
    "numberHeightFraction": 0.6,
    "numberAtlasCols": 8,
    "numberAtlasCellPx": 128,
    "numberFontFraction": 0.7,
    "helmetLiftFraction": 0.6,
    "capsuleCapSegments": 4,
    "capsuleRadialSegments": 10,
    "helmetWidthSegments": 12,
    "helmetHeightSegments": 8
  },
  "roster": {
    "numberRanges": {
      "QB": [
        1,
        19
      ],
      "K": [
        1,
        19
      ],
      "RB": [
        20,
        49
      ],
      "WR": [
        80,
        89
      ],
      "TE": [
        80,
        89
      ],
      "OL": [
        50,
        79
      ],
      "DL": [
        90,
        99
      ],
      "LB": [
        40,
        59
      ],
      "CB": [
        20,
        39
      ],
      "S": [
        20,
        49
      ]
    }
  },
  "look": {
    "sky": "#070b16",
    "grass": "#4a5a2c",
    "grassStripe": "#414f26",
    "surround": "#2e3a1d",
    "wall": "#0d0d0d",
    "goalpost": "#f2c200",
    "hemisphereSky": "#b8c6ff",
    "hemisphereGround": "#20381f",
    "hemisphereIntensity": 1.6,
    "keyLight": "#fff6e0",
    "keyLightIntensity": 2.6,
    "keyLightPosition": [
      18,
      45,
      40
    ],
    "ball": "#8a4b22",
    "iconOpen": "#22c55e",
    "iconContested": "#facc15",
    "iconCovered": "#ef4444",
    "skinTones": [
      "#8d5524",
      "#c68642",
      "#e0ac69",
      "#5c3a1e",
      "#a0673a",
      "#f1c27d",
      "#3d2314"
    ],
    "cleat": "#151515",
    "numberFont": "'Barlow Condensed', system-ui, sans-serif",
    "blackLift": 0.035,
    "skyTop": "#04060d",
    "skyHorizon": "#1b2a4a",
    "fog": "#0b1222",
    "fogNear": 90,
    "fogFar": 320,
    "rimLight": "#9fb6ff",
    "rimLightIntensity": 0.9,
    "rimLightPosition": [
      -20,
      25,
      -60
    ],
    "standConcrete": "#2a2d33",
    "crowdClothes": ["#e8e8e8", "#c9ccd2", "#8a8f98", "#4a505a", "#2b2f36", "#1f2a44", "#2e5ea8", "#7a1f2b", "#b03a2e", "#5b6b3a", "#c8a165", "#3d5a80"],
    "crowdHair": ["#1b1410", "#2a1d14", "#4a3020", "#6b4a2b", "#9a7b4f", "#2b2b2b", "#d8c9a8"],
    "standShadow": "#101216",
    "lightPanel": "#fffbe8",
    "lightGlow": "#fff3c4",
    "toneExposure": 1.05,
    "ballLaces": "#f4f4f4",
    "turfPuff": "#9fb08a",
    "grassWear": "#6b6339",
    "athleteRim": "#fff1d6",
    "athleteRimStrength": 0.45,
    "athleteRimPower": 2.6,
    "helmetSpecular": "#777777"
  },
  "ratings": {
    "min": 40,
    "max": 99,
    "offTraitMin": 40,
    "offTraitMax": 62,
    "home": {
      "min": 78,
      "max": 90
    },
    "away": {
      "min": 76,
      "max": 90
    }
  },
  "movement": {
    "baseSpeedYps": 6.5,
    "perSpdYps": 0.045,
    "releaseSeconds": 0.25,
    "qbDropYards": 1.5,
    "qbDropSeconds": 0.6,
    "dlPushYards": 1.2,
    "dlPushSeconds": 0.8,
    "olGiveYards": 0.6
  },
  "separation": {
    "noiseMin": -8,
    "noiseMax": 8,
    "breakBonus": 10,
    "breakBonusSeconds": 0.5,
    "deepPreBreakPenalty": -8,
    "deepRoutes": [
      "go",
      "post",
      "corner",
      "wheel"
    ],
    "routeVsCoverage": {
      "slant": {
        "zone": 6
      },
      "go": {
        "man": 4
      },
      "curl": {
        "man": 5
      },
      "post": {
        "cover2": 6
      }
    },
    "requiresFasterReceiver": [
      "go"
    ],
    "openAtOrAbove": 5,
    "coveredAtOrBelow": -5
  },
  "coverage": {
    "shells": [
      "man",
      "cover2",
      "cover3"
    ],
    "weights": {
      "default": {
        "man": 0.35,
        "cover2": 0.3,
        "cover3": 0.35
      },
      "shortYardage": {
        "man": 0.6,
        "cover2": 0.15,
        "cover3": 0.25
      },
      "long": {
        "man": 0.2,
        "cover2": 0.45,
        "cover3": 0.35
      }
    },
    "shortYardageToGo": 3,
    "longToGo": 8,
    "trailBaseYards": 1.2,
    "trailPerSepYards": 0.18,
    "trailMinYards": 0.3,
    "trailMaxYards": 7,
    "zoneRadiusYards": 9,
    "landmarks": {
      "cover2": [
        [
          -10.5,
          12
        ],
        [
          10.5,
          12
        ],
        [
          -9.0,
          22
        ],
        [
          9.0,
          22
        ],
        [
          -6.0,
          6
        ],
        [
          0.0,
          7
        ],
        [
          6.0,
          6
        ]
      ],
      "cover3": [
        [
          -12.8,
          18
        ],
        [
          0.0,
          22
        ],
        [
          12.8,
          18
        ],
        [
          -9.0,
          6
        ],
        [
          -3.0,
          7
        ],
        [
          3.0,
          7
        ],
        [
          9.0,
          6
        ]
      ],
      "man": [
        [
          0.0,
          14
        ]
      ]
    },
    "settleSeconds": 1.0
  },
  "throw": {
    "bandCentreBase": 35,
    "bandCentrePerYard": 1.2,
    "bandCentreMin": 40,
    "bandCentreMax": 90,
    "bandHalfWidthBase": 6,
    "bandHalfWidthThaDivisor": 15,
    "accuracyLossPerPoint": 0.03,
    "accuracyFloor": 0.4,
    "overthrowMargin": 15,
    "overthrowIncompleteChance": 70,
    "underthrowMargin": 15,
    "underthrowIntBonus": 12,
    "ballSpeedYps": 22,
    "minFlightSeconds": 0.45,
    "arcHeightPerYard": 0.12,
    "releaseHeightYards": 2.0,
    "catchHeightYards": 1.6
  },
  "catch": {
    "base": 38,
    "ratingFactor": 0.4,
    "sepFactor": 2,
    "timingBonus": {
      "perfect": 15,
      "good": 6,
      "miss": -12,
      "none": -20
    },
    "powerBonusInBand": 8,
    "powerBonusNear": -5,
    "powerBonusFar": -18,
    "powerNearPoints": 10,
    "qualityFactor": 20,
    "qualityPivot": 0.8,
    "min": 8,
    "max": 95,
    "dropLineAbove": 70,
    "defaultTiming": "good",
    "airYardsFree": 10,
    "perAirYard": 0.8
  },
  "interception": {
    "ratingFactor": 0.3,
    "negSepFactor": 1.5,
    "poorQualityBelow": 0.7,
    "poorQualityBonus": 15,
    "aggressiveBonus": 4,
    "min": 0,
    "max": 35
  },
  "yac": {
    "base": 2,
    "perSep": 0.35,
    "noise": 3,
    "max": 40,
    "breakawaySep": 10,
    "breakawayChance": 8
  },
  "drive": {
    "startBallOn": 25,
    "yardsToGain": 10,
    "maxDowns": 4
  },
  "playCall": {
    "playClockSeconds": 10,
    "autoSnapSeconds": 2
  },
  "ui": {
    "iconSizePx": 58,
    "iconGapPx": 6,
    "iconRefreshSeconds": 0.1,
    "safeEdgeFraction": 0.04,
    "safeBottomFraction": 0.08,
    "thumbZoneWidthFraction": 0.25,
    "thumbZoneHeightFraction": 0.25,
    "iconLiftYards": 1.4,
    "resultMinShowSeconds": 0.45,
    "endCardSeconds": 2.5,
    "tackleHoldSeconds": 0.6,
    "incompleteHoldSeconds": 0.8,
    "resultAfterHoldSeconds": 1.0,
    "holdToReadSeconds": 0.3,
    "cardMinShowSeconds": 0.4,
    "buttonGuardSeconds": 0.3
  },
  "cameraFollow": {
    "lerpPerSecond": 3.5,
    "pullbackPerYard": 0.12,
    "pullbackMaxYards": 8,
    "liftPerYard": 0.05,
    "liftMaxYards": 3
  },
  "ball": {
    "lengthYards": 0.31,
    "radiusYards": 0.093,
    "widthSegments": 10,
    "heightSegments": 8,
    "displayScale": 1,
    "carryTiltRad": 0.5,
    "carryBackYards": 0.06
  },
  "animation": {
    "ballHoldHeightYards": 1.2,
    "ballCarryHeightYards": 1.1,
    "incompleteDropYps": 4,
    "incompleteSkidYps": 2,
    "tackleOffsetYards": 0.6,
    "minYacSeconds": 0.3,
    "groundYards": 0.1
  },
  "run": {
    "sprintBonus": 0.12,
    "staminaDrainPerSecond": 25,
    "moveStaminaCost": 8,
    "breakStaminaCost": 15,
    "breakBase": 20,
    "breakPerPoint": 0.5,
    "timedBonus": 25,
    "timedWindowSeconds": 0.4,
    "staleAfterSeconds": 1.0,
    "fatiguePenalty": -15,
    "fatigueBelow": 20,
    "breakMin": 5,
    "breakMax": 85,
    "noMoveBase": 10,
    "noMovePerPoint": 0.3,
    "noMoveMin": 3,
    "noMoveMax": 40,
    "gangPenalty": 15,
    "contactRadiusYards": 0.9,
    "gangRadiusYards": 1.8,
    "jukeYards": 2.0,
    "jukeSeconds": 0.25,
    "spinSeconds": 0.45,
    "spinSpeedFactor": 0.85,
    "truckSeconds": 0.4,
    "brokenStumbleSeconds": 1.3,
    "brokenSlowFactor": 0.6,
    "brokenSlowSeconds": 0.35,
    "turnRateRadPerSecond": 7,
    "accelYps2": 14,
    "stickDeadzone": 0.2,
    "pursuitSpeedFactor": 1.05,
    "pursuitLeadMaxSeconds": 1.0,
    "pursuitLeadFactor": 0.6,
    "reactionSeconds": 0.3,
    "reactionPerYard": 0.015,
    "blockEngageRadiusYards": 1.3,
    "blockSeekRadiusYards": 7,
    "blockBaseSeconds": 1.3,
    "blockPerPoint": 0.04,
    "blockMinSeconds": 0.4,
    "blockMaxSeconds": 3.0,
    "blockDriftYps": 1.0,
    "blockerRestSeconds": 1.0,
    "fixedStepSeconds": 0.016666666666666666,
    "maxSeconds": 20,
    "forwardFallYards": 0.5,
    "truckFallYards": 1.2,
    "handoffSeconds": 0.55,
    "tossSeconds": 0.45,
    "intReturnMaxSeconds": 4,
    "closeYards": 3,
    "startSpeedFactor": 0.8,
    "catchSpeedFactor": 0.4,
    "breakdownYards": 1.3,
    "catchNoTackleSeconds": 0.6,
    "perfectNoTackleBonusSeconds": 0.1,
    "breakdownEaseYps": 3,
    "breakdownEngageYards": 1.95,
    "supportJogYps": 6,
    "supportGapYards": 3
  },
  "pocket": {
    "base": 2.6,
    "perPoint": 0.025,
    "min": 1.6,
    "max": 4.0,
    "sackAfterSeconds": 1.0,
    "pressurePenalty": 0.15,
    "latePenalty": 0.3,
    "lateWindowSeconds": 0.3,
    "closeYards": 0.6
  },
  "match": {
    "quarters": 4,
    "quarterSeconds": 60,
    "kickoffBallOn": 25,
    "twoMinuteDrillSeconds": 120,
    "oppBase": 4.5,
    "oppPerPoint": 0.1,
    "oppPassSd": 6,
    "oppRunSd": 3.5,
    "oppPassChance": 55,
    "oppTurnoverChance": 8,
    "oppTurnoverPerPoint": 0.4,
    "oppSecondsPerPlay": 1,
    "oppMaxPlays": 14,
    "oppRatingHome": 84,
    "oppRatingAway": 82,
    "fgRangeBase": 30,
    "fgRangePerKpw": 0.3,
    "fgSnapYards": 17,
    "fgMadeBase": 95,
    "fgPerYard": 1.2,
    "fgFreeYards": 30,
    "fgMin": 5,
    "fgMax": 98,
    "puntBase": 25,
    "puntPerKpw": 0.35,
    "puntNoise": 6,
    "patChance": 96,
    "touchbackBallOn": 20,
    "clockRunsBetweenPlaysSeconds": 4,
    "incompleteStopsClock": true,
    "oppKickerKpw": 80
  },
  "cameraChase": {
    "backYards": 8.5,
    "upYards": 8.5,
    "lookAheadYards": 8,
    "lookHeightYards": 0,
    "lerpPerSecond": 5,
    "ballBackYards": 13,
    "ballUpYards": 13,
    "shift": 0
  },
  "controls": {
    "tapMaxSeconds": 0.18,
    "holdFillSeconds": 1.2,
    "swipeMinPx": 40,
    "swipeMaxSeconds": 0.35,
    "stickRadiusPx": 60,
    "catchWindowSeconds": 0.6,
    "arcPoints": 32,
    "lobArcPerYard": 0.35,
    "bulletArcPerYard": 0.06,
    "catchPerfectEarlySeconds": 0.1,
    "catchPerfectLateSeconds": 0.05,
    "catchGoodEarlySeconds": 0.3,
    "catchLateGraceSeconds": 0.1,
    "catchTapGuardSeconds": 0.15
  },
  "fx": {
    "shakeTd": 0.5,
    "shakeDecayPerSecond": 4,
    "slowmoScale": 0.3,
    "slowmoSeconds": 0.35,
    "confettiCount": 260,
    "confettiSeconds": 3.0,
    "trailPoints": 14,
    "hapticSnapMs": 15,
    "hapticCatchMs": 30,
    "hapticHitMs": 60,
    "hapticTdMs": [
      60,
      40,
      120
    ],
    "bannerSeconds": 1.6,
    "popSeconds": 0.9,
    "shakeTackle": 0.55,
    "shakeBroke": 0.35,
    "shakeSack": 0.5,
    "shakeYards": 0.45,
    "joltYards": 0.35,
    "joltDecayPerSecond": 10,
    "hitStopSeconds": 0.08,
    "hitStopBrokeSeconds": 0.05,
    "puffCount": 28,
    "puffSeconds": 0.7,
    "puffSpeedYps": 3.2,
    "puffSizeYards": 0.22,
    "firstDownChimeHz": [
      784,
      1175
    ],
    "arcDots": 24,
    "arcDotYards": 0.85,
    "arcDotSpeed": 1.5,
    "trailWidthYards": 0.35,
    "ballShadowYards": 0.9,
    "ballShadowFadeYards": 12
  },
  "stadium": {
    "standRows": 3,
    "tierDepthYards": 24,
    "tierRiseYards": 13,
    "firstTierGapYards": 9,
    "upperGapYards": 3,
    "crowdTilePx": 1024,
    "signTextureScale": 2,
    "crowdRows": 22,
    "crowdCols": 26,
    "crowdBrandShare": 0.4,
    "crowdEmptyShare": 0.05,
    "crowdSeed": 7,
    "crowdBounceHz": 1.1,
    "crowdBounceCalm": 0.02,
    "crowdBounceCheer": 0.08,
    "crowdStandingShare": 0.04,
    "crowdCheerStandShare": 0.85,
    "crowdTileShade": 0.08,
    "boardHeightYards": 1.4,
    "boardEveryYards": 20,
    "towerHeightYards": 55,
    "towerInsetYards": 6,
    "glowSizeYards": 30,
    "fasciaHeightYards": 3,
    "benchPerSide": 12,
    "benchOffsetYards": 4.5
  },
  "audio": {
    "master": 0.7,
    "crowdBase": 0.12,
    "crowdCheer": 0.45,
    "crowdFilterHz": 900,
    "samples": {
      "crowd": "audio/crowd-loop.mp3",
      "cheer": "audio/crowd-cheer.mp3",
      "touchdown": "audio/announcer-touchdown.mp3",
      "itsGood": "audio/announcer-its-good.mp3"
    },
    "crowdSampleGain": 2.5,
    "crowdMuffledHz": 1800,
    "crowdOpenHz": 12000,
    "crowdSwapSeconds": 1.5,
    "loopTrimThreshold": 0.0005,
    "cheerGain": 0.9,
    "cheerSmallGain": 0.4,
    "announcerGain": 1.0,
    "cheerUnderCallGain": 0.5,
    "whistleHz": 2900,
    "hitGain": 0.9,
    "whooshGain": 0.35,
    "catchGain": 0.6,
    "hornGain": 0.35,
    "crackGain": 0.55,
    "crackHz": 2600,
    "thumpGain": 0.5,
    "whistleDelaySeconds": 0.35,
    "gradePerfectHz": [
      988,
      1480
    ],
    "gradeGoodHz": 1200,
    "gradeMissHz": 150
  },
  "guide": {
    "throwPauseSeconds": 1.0,
    "maxPauseSeconds": 8,
    "catchSlowScale": 0.4,
    "runHintCarries": 3,
    "storageKey": "gridiron-guide-v1"
  },
  "cameraCall": {
    "backYards": 8,
    "upYards": 3.6,
    "lookAheadYards": 22,
    "lookHeightYards": 1.4,
    "shift": 0.27,
    "lerpPerSecond": 3.5
  },
  "cameraCelebrate": {
    "frontYards": 7,
    "upYards": 2.8,
    "sideYards": 1.8,
    "lookHeightYards": 1.1,
    "shift": 0,
    "lerpPerSecond": 2.5
  },
  "cameraTackle": {
    "sideYards": 4.5,
    "backYards": 5.5,
    "upYards": 3.0,
    "lookHeightYards": 0.5,
    "shift": -0.18,
    "lerpPerSecond": 3
  },
  "athlete": {
    "modelUrl": "models/athlete.glb",
    "skinTextureUrl": "models/athlete-skin.webp",
    "normalTextureUrl": "models/athlete-normal.webp",
    "loadTimeoutSeconds": 8,
    "scale": 1.1,
    "blendRate": 10,
    "overlayRate": 14,
    "poseRate": 10,
    "speedRate": 10,
    "maxSpeedYps": 14,
    "turnSpeedYps": 1.2,
    "turnRate": 10,
    "movingYps": 0.6,
    "jogStrideMetres": 5.0,
    "sprintStrideMetres": 5.5,
    "stanceCrouch": 0.45,
    "qbCrouch": 0.3,
    "fallTimeScale": 1.4,
    "divePitch": 1.25,
    "diveSeconds": 0.3,
    "diveLiftYards": 0.15,
    "diveLiftSeconds": 0.4,
    "dance": {
      "grooveSeconds": 1.25,
      "spinSeconds": 0.7,
      "flexSeconds": 0.9375,
      "beatHz": 1.6,
      "twistRad": 0.45,
      "swayRad": 0.12,
      "bounceYards": 0.12,
      "spinHopYards": 0.25,
      "flexLeanRad": -0.15
    },
    "throwWindSeconds": 0.22,
    "throwReleaseSeconds": 0.4,
    "kitNormalFlatten": 0.7,
    "kitCuts": {
      "sleeve": 0.5,
      "glove": 0.88,
      "collar": 0.75,
      "waist": 0.7,
      "knee": 0.12,
      "sock": 0.92
    },
    "helmetTop": 0.25,
    "shadowYards": 1.4,
    "shadowOpacity": 0.55,
    "shadowDownScale": 1.4,
    "shadowLiftYards": 0.02,
    "gear": {
      "helmetOffset": [
        0,
        0.075,
        0.02
      ],
      "helmetScale": 0.55,
      "padsOffset": [
        0,
        0.2,
        -0.01
      ],
      "padsScale": 0.88,
      "numberFrontOffset": [
        0,
        0.09,
        0.2
      ],
      "numberBackOffset": [
        0,
        0.06,
        -0.19
      ],
      "numberSize": [
        0.26,
        0.22
      ],
      "shoeOffset": [
        0,
        -0.08,
        0.07
      ],
      "shoeSize": [
        0.12,
        0.1,
        0.31
      ],
      "logos": {
        "backOffset": [
          0,
          0.215,
          -0.175
        ],
        "backSize": [
          0.27,
          0.074
        ],
        "helmetOffset": [
          0.133,
          0.085,
          0.01
        ],
        "shoulderOffset": [
          0.141,
          0.295,
          -0.01
        ],
        "shoulderMarks": true,
        "markSize": 0.08,
        "texturePx": 256,
        "alphaTest": 0.35
      }
    },
    "hd": {
      "modelUrl": "models/athlete-hd.glb",
      "skinTextureUrl": "models/athlete-hd-skin.webp",
      "normalTextureUrl": "models/athlete-hd-normal.webp",
      "classify": {
        "accentGreenOverRed": 0.5,
        "accentBlueOverGreen": 0.3,
        "accentMin": 0.12,
        "skinBlueOverGreen": 0.3,
        "skinSaturationMin": 0.3,
        "skinMin": 0.04,
        "greySaturationMax": 0.25,
        "greyMin": 0.12
      },
      "gloveAt": 0.8,
      "shadeMax": 2.5,
      "gear": {
        "numberFrontOffset": [
          0,
          -0.1,
          0.19
        ],
        "numberBackOffset": [
          0,
          -0.093,
          -0.174
        ],
        "numberSize": [
          0.22,
          0.19
        ],
        "logos": {
          "backOffset": [
            0,
            0.03,
            -0.19
          ],
          "backSize": [
            0.25,
            0.07
          ],
          "helmetOffset": [
            0.112,
            0.13,
            0.0
          ],
          "markSize": 0.07,
          "shoulderMarks": false
        }
      }
    }
  }
}
